import debug from 'debug';
import Templates from './templates';

const log = debug('Spinner');
const templates = new Templates();

class Spinner {
	constructor() {
		this.initialize();
	}

	initialize() {
		this.setup();
	}

	setup() {
		const siteContainer = document.querySelector('.site-container');
		let svgDefsContainer = siteContainer.querySelector('[data-js="svg-defs-container"]');

		if (svgDefsContainer === null) {
			siteContainer.insertAdjacentHTML('beforeend', templates.svgDefsContainer());
			svgDefsContainer = siteContainer.querySelector('[data-js="svg-defs-container"]');
		}

		svgDefsContainer.insertAdjacentHTML('beforeend', templates.iconDef());
	}

	/**
	 * @param {string} cssClass
	 * @returns {string} markup
	 */
	use(cssClass) {
		return templates.useIcon(cssClass);
	}
}

export default Spinner;
